import { useCallback, useEffect, useRef, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Dropdown } from 'ui_kit_qmd'
import { getPatientAuditLogs } from '../../../../store/charts/ChartsThunk'

const METHOD_DROP_DOWN_STYLE = {
  height: 'auto',
  marginTop: 5,
  boxSizing: 'border-box',
}

// @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
export const useAuditLogs = ({ id }) => {
  const dispatch = useDispatch()

  // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
  const auditLogs = useSelector((state) => state.chartsReducer?.patientInfo?.[id]?.patientAuditLogs || [])
  const logType = useRef<string | null>(null)
  const [logTypeSelected, setLogTypeSelected] = useState('None')
  const [filteredAuditLogs, setFilteredAuditLogs] = useState([])

  useEffect(() => {
    if (id) {
      // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
      dispatch(getPatientAuditLogs(id, logType.current))
    }
  }, [id, logTypeSelected, dispatch])

  useEffect(() => {
    setFilteredAuditLogs(auditLogs)
  }, [auditLogs])

  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  const onSetLogTypeSelected = useCallback((value) => {
    setLogTypeSelected(value)
    switch (value) {
      case 'ID Verification':
        logType.current = 'identityverification'
        break
      case 'Orders':
        logType.current = 'order'
        break
      case 'Merge Activity':
        logType.current = 'accountmerge'
        break
      case 'Package':
        logType.current = 'package'
        break
      default:
        logType.current = null
    }
  }, [])

  const getLogFilter = useCallback(
    () => (
      <div className='audit-log-multiselect-dropdown-container'>
        <div className='audit-log-multiselect-dropdown'>
          <Dropdown
            isDisabled={false}
            options={['None', 'ID Verification', 'Orders', 'Merge Activity', 'Package']}
            value={logTypeSelected}
            setValue={onSetLogTypeSelected}
            dropdownContainerStyle={METHOD_DROP_DOWN_STYLE}
            dropId='audit-log-filter'
            label='Filters'
          />
        </div>
      </div>
    ),
    [logTypeSelected, onSetLogTypeSelected],
  )

  return { filteredAuditLogs, getLogFilter }
}
